// Pillar configuration and helper functions
import { getTodayInTimezone, formatDateFriendly, DEFAULT_TIMEZONE } from './timezone';

export const PILLAR_SLUGS = [
  'interior',
  'profissional',
  'espiritual',
  'saudavel',
  'social',
  'sentimental',
] as const;

export const ONBOARDING_STEPS = [
  { path: '/onboarding/intro', title: 'Boas-vindas' },
  { path: '/onboarding/roda', title: 'Roda da Vida' },
  { path: '/onboarding/identidade', title: 'Identidade Aspiracional' },
  { path: '/onboarding/rotina', title: 'Sua Rotina' },
  { path: '/onboarding/dados', title: 'Dados Pessoais' },
  { path: '/onboarding/compromisso', title: 'Compromisso' },
];

/**
 * @deprecated Use getTodayInTimezone from timezone.ts instead
 */
export function getTodayISO(timezone?: string): string {
  return getTodayInTimezone(timezone || DEFAULT_TIMEZONE);
}

/**
 * @deprecated Use formatDateFriendly from timezone.ts instead
 */
export function formatDate(isoString: string, timezone?: string): string {
  return formatDateFriendly(isoString, timezone || DEFAULT_TIMEZONE);
}

export function getWeekday(isoString: string): string {
  const date = new Date(isoString);
  return date.toLocaleDateString('pt-BR', { weekday: 'long' });
}

export const BOT_CONFIG = {
  name: 'Disciplinado',
  personality: 'coach empático e motivacional',
  emoji: '🎯'
} as const;
